import { Link } from "react-router-dom";

export default function Sms() {
  return (
    <article className="mkt-page">
      <header className="mkt-hero">
        <h1>SMS alerts</h1>
        <p>
          Opt in to CareerMaster account messages: registration and login
          verification codes, plus informational account alerts (for example
          match or interview reminders). No marketing or promotional texts.
        </p>
      </header>
      <section className="mkt-section">
        <h2>Text to join</h2>
        <p>
          Text <strong>JOIN</strong> to <strong>(866) 561-6241</strong> (
          <code>+18665616241</code>). You will receive a link to finish creating
          your account with your phone number already verified.
        </p>
        <p>
          Message frequency varies. Message and data rates may apply. Reply{" "}
          <strong>STOP</strong> to opt out. Reply <strong>HELP</strong> for help.
        </p>
        <p>
          <Link to="/privacy">Privacy Policy</Link>
          {" · "}
          <Link to="/terms">Terms</Link>
          {" · "}
          <a href="mailto:support@careermaster.com">support@careermaster.com</a>
        </p>
      </section>
      <section className="mkt-section">
        <h2>Web consent</h2>
        <p>
          You can also opt in during registration by entering your mobile number
          and checking the SMS consent box (not pre-checked). Providing a phone
          number is optional; you can create an account without SMS.
        </p>
      </section>
    </article>
  );
}
